import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
// eslint-disable-next-line import/extensions
import * as Icons from '../../assets/icons/index.js';
import s from './Tile.module.scss';

/**
 * The tile component is a radio button that is styled to look like a tile.
 * It's state needs to be controlled by the parent component via the *checked*
 * and *onChange* props.
 */
function Tile(props) {
  const { label, name, value, iconComponent, checked, onChange, intl } = props;
  const Icon = Icons[iconComponent];
  return (
    <button
      type="button"
      id={`${name}-${value}`}
      onClick={() => onChange(value)}
      className={s.button}
    >
      <div className={`${s.tile} ${checked ? s.checked : ''}`}>
        <div className={s.image}>
          <Icon role="presentation" focusable="false" />
        </div>
        <div className={s.labeltext}>
          <FormattedMessage id={label} />
          <span
            aria-label={`${
              checked ? intl.formatMessage({ id: 'previouslySelected' }) : ''
            }`}
          />
        </div>
      </div>
    </button>
  );
}

Tile.propTypes = {
  /** React-intl id of the label text */
  label: PropTypes.string.isRequired,
  /** Name of the form input this tile is part of */
  name: PropTypes.string.isRequired,
  /** The value this tile represents */
  value: PropTypes.string.isRequired,
  /** The name of the icon component to render, see icons/index.js for available icons */
  iconComponent: PropTypes.string.isRequired,
  /** True if this value is currently selected */
  checked: PropTypes.bool.isRequired,
  /** When the input is selected this will be called with the tile's value */
  onChange: PropTypes.func.isRequired,
  /** The intl object for text formatting */
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(Tile);
